module.exports = __webpack_public_path__ + "img/img2.edafbfc7.png";